import { Box, Grid } from '@chakra-ui/react'

export function ColumnsProduct() {
  return (
    <Box display="flex" flexDir="column" gap={4}>
      <Grid gridTemplateColumns="repeat(12, 1fr)" color="white" bgColor="#7fb603" fontSize="12px" textTransform="uppercase" fontWeight="bold" p={3}>
        <Box gridColumn="span 4" border="1px solid #7fb603">
          ITEM
        </Box>
        <Box gridColumn="span 1" border="1px solid #7fb603" textAlign="center">
          QTD.
        </Box>
        <Box gridColumn="span 2" border="1px solid #7fb603" textAlign="center">
          VALOR UNITÁRIO
        </Box>
        <Box gridColumn="span 2" border="1px solid #7fb603" textAlign="center">
          VALOR TOTAL
        </Box>

        <Box gridColumn="span 3" border="1px solid #7fb603" textAlign="center">
          LAYOUT
        </Box>
      </Grid>
    </Box>
  )
}
